import React from 'react';
import styles from './FloatingDecorations.module.scss';

const FloatingDecorations = () => (
    <div className={styles.decorations} aria-hidden="true">

        {/* 1 — Sword  (top-left) */}
        <div className={`${styles.deco} ${styles.d1}`}>
            <svg width="70" height="70" viewBox="0 0 64 64" fill="none">
                <path d="M50 4L60 14L20 42L8 56L4 60L8 56L14 50L42 20L50 4Z" stroke="#c471ed" strokeWidth="2.5" strokeLinejoin="round"/>
                <path d="M44 10L54 20" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                <circle cx="8" cy="56" r="5" fill="#9D3EF7" opacity="0.9"/>
                <path d="M18 46L22 50" stroke="#c471ed" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </div>

        {/* 2 — Gamepad  (top-right) */}
        <div className={`${styles.deco} ${styles.d2}`}>
            <svg width="80" height="80" viewBox="0 0 64 64" fill="none">
                <rect x="8" y="20" width="48" height="28" rx="14" stroke="#9D3EF7" strokeWidth="2.5"/>
                <line x1="20" y1="30" x2="20" y2="38" stroke="#c471ed" strokeWidth="2.5" strokeLinecap="round"/>
                <line x1="16" y1="34" x2="24" y2="34" stroke="#c471ed" strokeWidth="2.5" strokeLinecap="round"/>
                <circle cx="44" cy="30" r="3" fill="#e05252"/>
                <circle cx="50" cy="34" r="3" fill="#52aaff"/>
                <circle cx="44" cy="38" r="3" fill="#52e0a2"/>
                <circle cx="38" cy="34" r="3" fill="#ffd252"/>
                <ellipse cx="26" cy="20" rx="5" ry="3" fill="#1e0a3c" stroke="#9D3EF7" strokeWidth="1.5"/>
                <ellipse cx="38" cy="20" rx="5" ry="3" fill="#1e0a3c" stroke="#9D3EF7" strokeWidth="1.5"/>
            </svg>
        </div>

        {/* 3 — Crown  (top-center-right) */}
        <div className={`${styles.deco} ${styles.d3}`}>
            <svg width="68" height="68" viewBox="0 0 64 64" fill="none">
                <path d="M8 48H56L50 24L38 36L32 16L26 36L14 24L8 48Z" stroke="#ffd252" strokeWidth="2.5" fill="rgba(255,210,82,0.1)" strokeLinejoin="round"/>
                <circle cx="14" cy="24" r="3.5" fill="#ffd252"/>
                <circle cx="32" cy="16" r="3.5" fill="#ffd252"/>
                <circle cx="50" cy="24" r="3.5" fill="#ffd252"/>
                <rect x="8" y="50" width="48" height="5" rx="2" fill="rgba(255,210,82,0.2)" stroke="#ffd252" strokeWidth="1.5"/>
            </svg>
        </div>

        {/* 4 — Shield  (mid-right) */}
        <div className={`${styles.deco} ${styles.d4}`}>
            <svg width="66" height="66" viewBox="0 0 64 64" fill="none">
                <path d="M32 6L54 16V32C54 44 32 58 32 58C32 58 10 44 10 32V16L32 6Z" stroke="#52aaff" strokeWidth="2.5" fill="rgba(82,170,255,0.08)" strokeLinejoin="round"/>
                <path d="M24 32L30 38L42 26" stroke="#52aaff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>

        {/* 5 — Star  (mid-left) */}
        <div className={`${styles.deco} ${styles.d5}`}>
            <svg width="62" height="62" viewBox="0 0 64 64" fill="none">
                <path d="M32 6L38.5 24H58L43 35.5L49 54L32 43L15 54L21 35.5L6 24H25.5L32 6Z" stroke="#ffd252" strokeWidth="2" fill="rgba(255,210,82,0.12)" strokeLinejoin="round"/>
            </svg>
        </div>

        {/* 6 — Lightning  (lower-left) */}
        <div className={`${styles.deco} ${styles.d6}`}>
            <svg width="54" height="54" viewBox="0 0 64 64" fill="none">
                <path d="M38 6L18 36H32L26 58L46 28H32L38 6Z" stroke="#c471ed" strokeWidth="2.5" fill="rgba(196,113,237,0.15)" strokeLinejoin="round"/>
            </svg>
        </div>

        {/* 7 — Diamond  (lower-right) */}
        <div className={`${styles.deco} ${styles.d7}`}>
            <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
                <path d="M32 6L54 26L32 58L10 26L32 6Z" stroke="#52e0a2" strokeWidth="2" fill="rgba(82,224,162,0.1)" strokeLinejoin="round"/>
                <path d="M18 26H46" stroke="#52e0a2" strokeWidth="1.5"/>
                <path d="M14 22L32 6L50 22" stroke="#52e0a2" strokeWidth="1.5" strokeLinejoin="round"/>
            </svg>
        </div>

        {/* 8 — Pixel character  (right-center) */}
        <div className={`${styles.deco} ${styles.d8}`}>
            <svg width="58" height="58" viewBox="0 0 32 32" fill="none">
                <rect x="10" y="2" width="12" height="10" rx="1" fill="rgba(157,62,247,0.25)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="8" y="12" width="16" height="10" rx="1" fill="rgba(157,62,247,0.18)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="8" y="22" width="5" height="8" rx="1" fill="rgba(157,62,247,0.18)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="19" y="22" width="5" height="8" rx="1" fill="rgba(157,62,247,0.18)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="2" y="13" width="6" height="7" rx="1" fill="rgba(157,62,247,0.18)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="24" y="13" width="6" height="7" rx="1" fill="rgba(157,62,247,0.18)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="13" y="5" width="3" height="3" fill="#fff"/>
                <rect x="17" y="5" width="3" height="3" fill="#fff"/>
            </svg>
        </div>

        {/* 9 — Crosshair  (top-center-left) */}
        <div className={`${styles.deco} ${styles.d9}`}>
            <svg width="58" height="58" viewBox="0 0 64 64" fill="none">
                <circle cx="32" cy="32" r="20" stroke="#e05252" strokeWidth="2"/>
                <circle cx="32" cy="32" r="5" stroke="#e05252" strokeWidth="2"/>
                <line x1="32" y1="4" x2="32" y2="20" stroke="#e05252" strokeWidth="2" strokeLinecap="round"/>
                <line x1="32" y1="44" x2="32" y2="60" stroke="#e05252" strokeWidth="2" strokeLinecap="round"/>
                <line x1="4" y1="32" x2="20" y2="32" stroke="#e05252" strokeWidth="2" strokeLinecap="round"/>
                <line x1="44" y1="32" x2="60" y2="32" stroke="#e05252" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </div>

        {/* 10 — Potion  (bottom-center) */}
        <div className={`${styles.deco} ${styles.d10}`}>
            <svg width="56" height="56" viewBox="0 0 64 64" fill="none">
                <rect x="27" y="6" width="10" height="10" rx="2" stroke="#52e0a2" strokeWidth="2" fill="rgba(82,224,162,0.1)"/>
                <path d="M22 16H42L50 38C50 48 14 48 14 38L22 16Z" stroke="#52e0a2" strokeWidth="2" fill="rgba(82,224,162,0.08)" strokeLinejoin="round"/>
                <ellipse cx="32" cy="36" rx="8" ry="5" fill="rgba(82,224,162,0.25)"/>
                <circle cx="26" cy="30" r="2" fill="#52e0a2" opacity="0.6"/>
                <circle cx="38" cy="33" r="1.5" fill="#52e0a2" opacity="0.4"/>
            </svg>
        </div>

        {/* 11 — Joystick  (bottom-left) */}
        <div className={`${styles.deco} ${styles.d11}`}>
            <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
                <ellipse cx="32" cy="50" rx="20" ry="8" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.1)"/>
                <rect x="28" y="24" width="8" height="26" rx="4" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.1)"/>
                <circle cx="32" cy="20" r="10" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.15)"/>
                <circle cx="32" cy="20" r="4" fill="#9D3EF7" opacity="0.6"/>
            </svg>
        </div>

        {/* 12 — Gem ring  (bottom-right) */}
        <div className={`${styles.deco} ${styles.d12}`}>
            <svg width="56" height="56" viewBox="0 0 64 64" fill="none">
                <circle cx="32" cy="40" rx="16" ry="8" stroke="#52aaff" strokeWidth="2" fill="none" transform="rotate(-10 32 40)"/>
                <path d="M20 28L32 12L44 28L32 36L20 28Z" stroke="#52aaff" strokeWidth="2" fill="rgba(82,170,255,0.15)" strokeLinejoin="round"/>
                <line x1="20" y1="28" x2="44" y2="28" stroke="#52aaff" strokeWidth="1.5"/>
            </svg>
        </div>

        {/* 13 — Katana  (center-left) */}
        <div className={`${styles.deco} ${styles.d13}`}>
            <svg width="72" height="72" viewBox="0 0 64 64" fill="none">
                <path d="M8 56L52 8" stroke="#c471ed" strokeWidth="2" strokeLinecap="round"/>
                <path d="M52 8L58 6L56 12L52 8Z" fill="#ffd252" stroke="#ffd252" strokeWidth="1"/>
                <path d="M8 56L4 62L12 60Z" fill="#c471ed"/>
                <path d="M36 24L40 20" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
                <path d="M28 32L32 28" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
                <rect x="6" y="54" width="8" height="4" rx="1" transform="rotate(-45 6 54)" fill="rgba(157,62,247,0.6)" stroke="#9D3EF7" strokeWidth="1"/>
            </svg>
        </div>

        {/* 14 — Skull  (top-center) */}
        <div className={`${styles.deco} ${styles.d14}`}>
            <svg width="62" height="62" viewBox="0 0 64 64" fill="none">
                <path d="M32 8C18 8 10 18 10 28C10 36 14 42 20 45V52H44V45C50 42 54 36 54 28C54 18 46 8 32 8Z" stroke="#e05252" strokeWidth="2" fill="rgba(224,82,82,0.1)" strokeLinejoin="round"/>
                <circle cx="24" cy="28" r="5" fill="rgba(224,82,82,0.25)" stroke="#e05252" strokeWidth="1.5"/>
                <circle cx="40" cy="28" r="5" fill="rgba(224,82,82,0.25)" stroke="#e05252" strokeWidth="1.5"/>
                <path d="M26 44V52" stroke="#e05252" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M32 44V52" stroke="#e05252" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M38 44V52" stroke="#e05252" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M28 32L36 32" stroke="#e05252" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
        </div>

        {/* 15 — Rocket  (center) */}
        <div className={`${styles.deco} ${styles.d15}`}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                <path d="M32 6C32 6 46 14 46 32L32 46L18 32C18 14 32 6 32 6Z" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.12)" strokeLinejoin="round"/>
                <circle cx="32" cy="26" r="6" stroke="#52aaff" strokeWidth="2" fill="rgba(82,170,255,0.15)"/>
                <path d="M22 42L14 52L24 50L22 42Z" stroke="#e05252" strokeWidth="1.5" fill="rgba(224,82,82,0.2)" strokeLinejoin="round"/>
                <path d="M42 42L50 52L40 50L42 42Z" stroke="#e05252" strokeWidth="1.5" fill="rgba(224,82,82,0.2)" strokeLinejoin="round"/>
                <path d="M28 48C28 52 36 52 36 48" stroke="#ffd252" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </div>

        {/* 16 — D20 dice  (center-right) */}
        <div className={`${styles.deco} ${styles.d16}`}>
            <svg width="66" height="66" viewBox="0 0 64 64" fill="none">
                <path d="M32 4L56 18V46L32 60L8 46V18L32 4Z" stroke="#52e0a2" strokeWidth="2" fill="rgba(82,224,162,0.08)" strokeLinejoin="round"/>
                <path d="M32 4L56 18L32 26L8 18L32 4Z" stroke="#52e0a2" strokeWidth="1.5" fill="rgba(82,224,162,0.1)" strokeLinejoin="round"/>
                <path d="M32 26L8 18V46L32 60V26Z" stroke="#52e0a2" strokeWidth="1" fill="rgba(82,224,162,0.05)"/>
                <path d="M32 26L56 18V46L32 60V26Z" stroke="#52e0a2" strokeWidth="1" fill="rgba(82,224,162,0.08)"/>
                <text x="32" y="44" textAnchor="middle" fill="#52e0a2" fontSize="12" fontWeight="bold" opacity="0.7">20</text>
            </svg>
        </div>

        {/* 17 — Fire  (center-left low) */}
        <div className={`${styles.deco} ${styles.d17}`}>
            <svg width="58" height="58" viewBox="0 0 64 64" fill="none">
                <path d="M32 56C20 56 12 46 12 36C12 24 22 18 26 10C26 10 24 22 32 24C32 24 28 16 36 10C36 10 38 22 44 28C48 32 52 36 52 42C52 50 44 56 32 56Z" stroke="#ffd252" strokeWidth="2" fill="rgba(255,210,82,0.1)" strokeLinejoin="round"/>
                <path d="M32 56C26 56 22 50 22 44C22 38 26 34 30 30C30 30 28 38 34 40C34 40 32 34 38 30C38 30 40 38 42 42C42 46 38 56 32 56Z" stroke="#e05252" strokeWidth="1.5" fill="rgba(224,82,82,0.15)" strokeLinejoin="round"/>
                <circle cx="32" cy="46" r="4" fill="rgba(255,210,82,0.3)"/>
            </svg>
        </div>

        {/* 18 — Spider web  (center-right low) */}
        <div className={`${styles.deco} ${styles.d18}`}>
            <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
                <circle cx="32" cy="32" r="26" stroke="#c471ed" strokeWidth="1.5" opacity="0.6"/>
                <circle cx="32" cy="32" r="18" stroke="#c471ed" strokeWidth="1.5" opacity="0.6"/>
                <circle cx="32" cy="32" r="10" stroke="#c471ed" strokeWidth="1.5" opacity="0.6"/>
                <circle cx="32" cy="32" r="3" fill="#c471ed" opacity="0.8"/>
                <line x1="32" y1="6" x2="32" y2="58" stroke="#c471ed" strokeWidth="1" opacity="0.5"/>
                <line x1="6" y1="32" x2="58" y2="32" stroke="#c471ed" strokeWidth="1" opacity="0.5"/>
                <line x1="13" y1="13" x2="51" y2="51" stroke="#c471ed" strokeWidth="1" opacity="0.5"/>
                <line x1="51" y1="13" x2="13" y2="51" stroke="#c471ed" strokeWidth="1" opacity="0.5"/>
            </svg>
        </div>

        {/* 19 — Medal  (bottom-center-left) */}
        <div className={`${styles.deco} ${styles.d19}`}>
            <svg width="62" height="62" viewBox="0 0 64 64" fill="none">
                <path d="M22 6H42L48 20H16L22 6Z" stroke="#ffd252" strokeWidth="2" fill="rgba(255,210,82,0.12)" strokeLinejoin="round"/>
                <circle cx="32" cy="42" r="18" stroke="#ffd252" strokeWidth="2" fill="rgba(255,210,82,0.08)"/>
                <path d="M32 28L34.9 36.6H44L36.5 41.8L39.4 50.4L32 45.2L24.6 50.4L27.5 41.8L20 36.6H29.1L32 28Z" fill="rgba(255,210,82,0.3)" stroke="#ffd252" strokeWidth="1"/>
                <line x1="24" y1="6" x2="28" y2="20" stroke="#ffd252" strokeWidth="1" opacity="0.5"/>
                <line x1="36" y1="6" x2="36" y2="20" stroke="#ffd252" strokeWidth="1" opacity="0.5"/>
            </svg>
        </div>

        {/* 20 — SNES Controller  (bottom-center-right) */}
        <div className={`${styles.deco} ${styles.d20}`}>
            <svg width="72" height="72" viewBox="0 0 64 64" fill="none">
                <path d="M10 26C6 26 4 30 4 34C4 38 6 44 10 46L20 50H44L54 46C58 44 60 38 60 34C60 30 58 26 54 26H10Z" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.1)" strokeLinejoin="round"/>
                <rect x="12" y="32" width="5" height="12" rx="1" fill="rgba(157,62,247,0.3)" stroke="#9D3EF7" strokeWidth="1"/>
                <rect x="9" y="35" width="11" height="6" rx="1" fill="rgba(157,62,247,0.3)" stroke="#9D3EF7" strokeWidth="1"/>
                <circle cx="44" cy="34" r="3" fill="#e05252" opacity="0.7"/>
                <circle cx="50" cy="38" r="3" fill="#52aaff" opacity="0.7"/>
                <circle cx="44" cy="42" r="3" fill="#52e0a2" opacity="0.7"/>
                <circle cx="38" cy="38" r="3" fill="#ffd252" opacity="0.7"/>
                <rect x="26" y="34" width="5" height="4" rx="1" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.4)" strokeWidth="1"/>
                <rect x="33" y="34" width="5" height="4" rx="1" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.4)" strokeWidth="1"/>
            </svg>
        </div>

    </div>
);

export default FloatingDecorations;
